module.exports = __webpack_public_path__ + "img/pic_search_empty@2x.af7e1ab9.png";